import { useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

import { ReactComponent as MoreIcon } from "assets/images/icons/TopNavIcons/MoreIcon.svg";
import testIds from "constants/testIds";
import UnsubscribeMenuItem from "components/molecules/TopNav/GuestNavIcons/Unsubscribe/UnsubscribeMenuItem";
import UnsubscribeDialog from "components/molecules/TopNav/GuestNavIcons/Unsubscribe/UnsubscribeDialog";

export default function GuestMenu() {
  const [isOpenUnsubscribeDialog, setIsOpenUnsubscribeDialog] = useState(false);

  const menuItems = [<UnsubscribeMenuItem setIsOpenUnsubscribeDialog={setIsOpenUnsubscribeDialog} />];

  return (
    <div className="d-flex" data-testid={testIds.TOPNAV_V2_GUEST_ACTIONS_CONTAINER}>
      <UnsubscribeDialog isOpen={isOpenUnsubscribeDialog} onClose={() => setIsOpenUnsubscribeDialog(false)} />
      <OverlayTrigger
        trigger="click"
        placement="bottom-end"
        overlay={
          <Popover id="v2-more-actions-popover" className="v2-more-actions-popover">
            <Popover.Content
              style={{ padding: 0 }}
              className="hide-during-print"
              data-testid={testIds.TOPNAV_V2_GUEST_ACTIONS_MENU}
            >
              {menuItems.map((icon, index) => (
                <div
                  key={index}
                  onClick={() => document.body.click()}
                  data-testid={`${testIds.TOPNAV_V2_GUEST_ACTIONS_ITEM_PREFIX}${index}`}
                >
                  {icon}
                </div>
              ))}
            </Popover.Content>
          </Popover>
        }
        rootClose
      >
        <button
          type="button"
          className="topnav-v2__action-btn"
          aria-label="More options"
          data-testid={testIds.TOPNAV_V2_GUEST_ACTIONS_MORE_ICON}
        >
          <MoreIcon />
        </button>
      </OverlayTrigger>
    </div>
  );
}
